// import { BrowserModule } from '@angular/platform-browser';
// import { NgModule } from '@angular/core';
// import { FormsModule,ReactiveFormsModule } from '@angular/forms';
// // import { AgmCoreModule } from '@agm/core';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { ToastrModule } from 'ngx-toastr';

// import { AppRoutingModule } from './app-routing.module';
// import { AppComponent } from './app.component';
// import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
// import { BlogsidebarComponent } from './components/layouts/blogsidebar/blogsidebar.component';
// import { ShopsidebarComponent } from './components/layouts/shopsidebar/shopsidebar.component';
// import { HeaderComponent } from './components/layouts/header/header.component';
// import { FooterComponent } from './components/layouts/footer/footer.component';
// import { ErrorComponent } from './components/pages/error/error.component';
// import { HomeComponent } from './components/pages/home/home.component';
// import { AuthService } from './services/auth.service';
// import { FocusDirective } from './directive/focus.directive';
// import { NumberOnlyDirective } from './directive/numberOnly.directive';
// import { DatepickerModule, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
// import { NgxMaskModule, IConfig } from 'ngx-mask';
// import { ChangeInputDirective } from './directive/change-input.directive';
// import { HttpClientModule } from '@angular/common/http';
// import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
// import { FormulaireComponent } from './components/pages/formulaire/formulaire.component';
// import { PopoverModule } from 'ngx-bootstrap/popover';
// import localeFr from '@angular/common/locales/fr';
// import { DatePipe, registerLocaleData } from '@angular/common';
// import { defineLocale, frLocale } from 'ngx-bootstrap/chronos';
// import {Ng2TelInputModule} from 'ng2-tel-input';
// import { NgSelectModule } from '@ng-select/ng-select';
// export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};
// registerLocaleData(localeFr, 'fr');
// defineLocale('fr', frLocale);
// import { BsModalService } from 'ngx-bootstrap/modal';
// import {HTTP_INTERCEPTORS } from '@angular/common/http';
// import { Interceptor } from './services/interceptor';
// import { ArchwizardModule } from 'angular-archwizard';
// import { AutomobileComponent} from './components/pages/automobile/automobile.component';
// import {NgbDateParserFormatter, NgbModule, NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';
// import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
// import { SubscriptionService } from './services/subscription.service';
// import { ModalModule } from 'ngx-bootstrap/modal';
// import { LoginComponent } from './components/pages/login/login.component';
// import { RegisterComponent } from './components/pages/register/register.component';
// import { ActivateAccountComponent } from './components/pages/activation-account/activation-account.component';
// import { VoyageComponent } from './components/pages/voyage/voyage.component';
// import { SanteComponent } from './components/pages/sante/sante.component';
// import { MrhComponent } from './components/pages/mrh/mrh.component';
// import { MrpComponent } from './components/pages/mrp/mrp.component';
// import { IndividuelleAccidentComponent } from './components/pages/individuelle-accident/individuelle-accident.component';
// import { RceComponent } from './components/pages/rce/rce.component';
// import { StockMarchandisesComponent } from './components/pages/stock/stock.component';
// import { FlotteComponent } from './components/pages/flotte/flotte.component';
// import { EducationComponent } from './components/pages/education/education.component';
// import { RetraiteComponent } from './components/pages/retraite/retraite.component';
// import { DecesComponent } from './components/pages/deces/deces.component';
// import { NoAutocompleteDirective } from './directive/no-autocomplete.directive';

// @NgModule({
//   declarations: [
//     AppComponent,
//     PreloaderComponent,
//     BlogsidebarComponent,
//     ShopsidebarComponent,
//     HeaderComponent,
//     FooterComponent,
//     ErrorComponent,
//     HomeComponent,
//     FormulaireComponent,
//     FocusDirective,
//     NumberOnlyDirective,
//     ChangeInputDirective,
//     AutomobileComponent,
//     LoginComponent,
//     RegisterComponent,
//     ActivateAccountComponent,
//     VoyageComponent,
//     SanteComponent,
//     MrhComponent,
//     MrpComponent,
//     IndividuelleAccidentComponent,
//     RceComponent,
//     StockMarchandisesComponent,
//     FlotteComponent,
//     EducationComponent,
//     RetraiteComponent,
//     DecesComponent,
//     NoAutocompleteDirective 
//   ],
//   imports: [
//     BrowserModule,
//     AppRoutingModule,
//     FormsModule,
//     ReactiveFormsModule,
//     HttpClientModule,
//     BrowserAnimationsModule,
//     PopoverModule,
//     ToastrModule.forRoot(),
//     SweetAlert2Module.forRoot(),
//     NgSelectModule,
//     // AgmCoreModule.forRoot({
//     //   apiKey: 'AIzaSyAwMP4QNMrB3z7ozZAMKOb1sQpk5eKJLFg'
//     // }),
//     DatepickerModule.forRoot(),
//     BsDatepickerModule.forRoot(),
//     NgxMaskModule.forRoot(),
//     Ng2TelInputModule,
//     ArchwizardModule,
//     NgbModule,
//     NgxBootstrapMultiselectModule,
//     ModalModule.forRoot()
//   ],
//   exports:[DatepickerModule,
//     BsDatepickerModule,
//     NgxMaskModule,
//     PopoverModule,
//     NgSelectModule
//   ],
//   providers: [AuthService,BsModalService,DatePipe,SubscriptionService,
//     {
//       provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true
//     },
//   ],
//   bootstrap: [AppComponent],
//   entryComponents: [LoginComponent, RegisterComponent] 
// })
// export class AppModule { }

import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
import { BlogsidebarComponent } from './components/layouts/blogsidebar/blogsidebar.component';
import { ShopsidebarComponent } from './components/layouts/shopsidebar/shopsidebar.component';
import { HeaderComponent } from './components/layouts/header/header.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { HomeComponent } from './components/pages/home/home.component';
import { AuthService } from './services/auth.service';
import { FocusDirective } from './directive/focus.directive';
import { NumberOnlyDirective } from './directive/numberOnly.directive';
import { DatepickerModule, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ChangeInputDirective } from './directive/change-input.directive';
import { HttpClientModule } from '@angular/common/http';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { FormulaireComponent } from './components/pages/formulaire/formulaire.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import localeFr from '@angular/common/locales/fr';
import { DatePipe, registerLocaleData } from '@angular/common';
import { defineLocale, frLocale } from 'ngx-bootstrap/chronos';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsModalService } from 'ngx-bootstrap/modal';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from './services/interceptor';
import { ArchwizardModule } from 'angular-archwizard';
import { AutomobileComponent } from './components/pages/automobile/automobile.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import { SubscriptionService } from './services/subscription.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { LoginComponent } from './components/pages/login/login.component';
import { RegisterComponent } from './components/pages/register/register.component';
import { ActivateAccountComponent } from './components/pages/activation-account/activation-account.component';
import { VoyageComponent } from './components/pages/voyage/voyage.component';
import { SanteComponent } from './components/pages/sante/sante.component';
import { MrhComponent } from './components/pages/mrh/mrh.component';
import { MrpComponent } from './components/pages/mrp/mrp.component';
import { IndividuelleAccidentComponent } from './components/pages/individuelle-accident/individuelle-accident.component';
import { RceComponent } from './components/pages/rce/rce.component';
import { StockMarchandisesComponent } from './components/pages/stock/stock.component';
import { FlotteComponent } from './components/pages/flotte/flotte.component';
import { EducationComponent } from './components/pages/education/education.component';
import { RetraiteComponent } from './components/pages/retraite/retraite.component';
import { DecesComponent } from './components/pages/deces/deces.component';
import { NoAutocompleteDirective } from './directive/no-autocomplete.directive';
import { AppInitService } from './services/app-init.service';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};
registerLocaleData(localeFr, 'fr');
defineLocale('fr', frLocale);

// Factory simple qui appelle le service d'initialisation
export function initializeApp(appInitService: AppInitService): () => Promise<any> {
  return () => appInitService.init();
}

@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    BlogsidebarComponent,
    ShopsidebarComponent,
    HeaderComponent,
    FooterComponent,
    ErrorComponent,
    HomeComponent,
    FormulaireComponent,
    FocusDirective,
    NumberOnlyDirective,
    ChangeInputDirective,
    AutomobileComponent,
    LoginComponent,
    RegisterComponent,
    ActivateAccountComponent,
    VoyageComponent,
    SanteComponent,
    MrhComponent,
    MrpComponent,
    IndividuelleAccidentComponent,
    RceComponent,
    StockMarchandisesComponent,
    FlotteComponent,
    EducationComponent,
    RetraiteComponent,
    DecesComponent,
    NoAutocompleteDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    PopoverModule,
    ToastrModule.forRoot(),
    SweetAlert2Module.forRoot(),
    NgSelectModule,
    DatepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgxMaskModule.forRoot(),
    Ng2TelInputModule,
    ArchwizardModule,
    NgbModule,
    NgxBootstrapMultiselectModule,
    ModalModule.forRoot()
  ],
  exports: [
    DatepickerModule,
    BsDatepickerModule,
    NgxMaskModule,
    PopoverModule,
    NgSelectModule
  ],
  providers: [
    AuthService,
    BsModalService,
    DatePipe,
    SubscriptionService,
    AppInitService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
  entryComponents: [LoginComponent, RegisterComponent]
})
export class AppModule { }
